export default __webpack_public_path__ + "static/media/Turbo.b985c269.svg";